import apiClient from './client';

export const staffAPI = {
  list: (params) => apiClient.get('/staff', { params }),
  get: (id) => apiClient.get(`/staff/${id}`),
  create: (data) => apiClient.post('/staff', data),
  update: (id, data) => apiClient.put(`/staff/${id}`, data),
  uploadPhoto: (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post(`/staff/${id}/photo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  catalogList: (params) => apiClient.get('/equipment-catalog', { params }),
  catalogCreate: (data) => apiClient.post('/equipment-catalog', data),
  catalogUpdate: (id, data) => apiClient.put(`/equipment-catalog/${id}`, data),
  eventStaff: (eventId) => apiClient.get(`/events/${eventId}/staff`),
  assignStaff: (eventId, assignments) => apiClient.post(`/events/${eventId}/staff`, { assignments }),
  updateAssignment: (eventId, assignId, data) => apiClient.put(`/events/${eventId}/staff/${assignId}`, data),
  removeStaff: (eventId, assignId) => apiClient.delete(`/events/${eventId}/staff/${assignId}`),
  recordPayment: (eventId, assignId, amountPaid, notes, receiptUrl) =>
    apiClient.post(`/events/${eventId}/staff/${assignId}/payment`, {
      amount_paid: amountPaid,
      payment_notes: notes || null,
      receipt_url: receiptUrl || null,
    }),
  uploadReceipt: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiClient.post('/public/payments/upload-receipt', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  returnEquipment: (eventId, assignId, itemId, data) =>
    apiClient.patch(`/events/${eventId}/staff/${assignId}/equipment/${itemId}/return`, data),
  addEquipment: (eventId, assignId, equipmentId, quantity, condition = 'bueno', notes = null) =>
    apiClient.post(`/events/${eventId}/staff/${assignId}/equipment`, {
      equipment_id: equipmentId,
      quantity_assigned: quantity,
      condition_on_delivery: condition,
      notes,
    }),
  listEquipmentCatalog: () => apiClient.get('/equipment-catalog'),
  bulkEquipment: (eventId, staffIds, equipment) =>
    apiClient.post(`/events/${eventId}/staff/equipment/bulk`, { staff_ids: staffIds, equipment }),
  getAttendance: (eventId) => apiClient.get(`/events/${eventId}/attendance`),
  recordAttendance: (eventId, date, records) =>
    apiClient.post(`/events/${eventId}/attendance`, { date, records }),
  getQrRegistrations: (eventId) => apiClient.get(`/qr-registrations/${eventId}`)
    .then(r => ({ ...r, data: Array.isArray(r.data) ? r.data : (r.data.items || r.data.registrations || []) })),
  publicEventInfo: (eventId) => apiClient.get(`/public/events/${eventId}/register-info`),
  publicRegister: (eventId, data) => apiClient.post(`/public/events/${eventId}/register`, data),
  getExtended: (staffId) => apiClient.get(`/staff-extended/${staffId}`),
  setExtended: (staffId, data) => apiClient.put(`/staff-extended/${staffId}`, data),
};

export const EQUIPMENT_CATEGORIES = {
  vestimenta:   { label: 'Vestimenta',    emoji: '👕' },
  comunicacion: { label: 'Comunicación',  emoji: '📻' },
  iluminacion:  { label: 'Iluminación',   emoji: '🔦' },
  seguridad:    { label: 'Seguridad',     emoji: '🛡' },
  otro:         { label: 'Otro',          emoji: '📦' },
};

export const ATTENDANCE_STATUS = {
  presente:    { label: 'Presente',   bg: 'bg-green-100 text-green-800',  dot: 'bg-green-500'  },
  tardanza:    { label: 'Tardanza',   bg: 'bg-yellow-100 text-yellow-800', dot: 'bg-yellow-500' },
  ausente:     { label: 'Ausente',    bg: 'bg-red-100 text-red-800',      dot: 'bg-red-500'    },
  justificado: { label: 'Justificado',bg: 'bg-blue-100 text-blue-800',    dot: 'bg-blue-500'   },
};

export const PAYMENT_STATUS = {
  pendiente: { label: 'Pendiente', bg: 'bg-red-100 text-red-800 border-red-200'     },
  parcial:   { label: 'Parcial',   bg: 'bg-orange-100 text-orange-800 border-orange-200' },
  pagado:    { label: 'Pagado',    bg: 'bg-green-100 text-green-800 border-green-200'    },
};

export const GENDER_OPTIONS = {
  masculino:  { label: 'Masculino',        emoji: '♂' },
  femenino:   { label: 'Femenino',         emoji: '♀' },
  otro:       { label: 'Otro',             emoji: '⚧' },
  no_declara: { label: 'Prefiero no decir', emoji: '—' },
};

export const PRESET_SHIFTS = [
  { name: 'Mañana', start_time: '07:00', end_time: '15:00' },
  { name: 'Tarde',  start_time: '15:00', end_time: '23:00' },
  { name: 'Noche',  start_time: '23:00', end_time: '07:00' },
];

export const CONDITION_OPTIONS = ['bueno','regular','malo','perdido','dañado'];
